import { PayloadType, TestKitStateType } from "@/common/types";
import Types from "../types";

const testKitInitialState: TestKitStateType = {
  testKits: null,
  testKitDetail: null,
  visualization: {},
};

export const testKitReducer = (
  state = testKitInitialState,
  action: PayloadType
) => {
  switch (action.type) {
    case Types.SET_TEST_KITS:
      return {
        ...state,
        testKits: action.payload,
      };
    case Types.SET_TEST_KIT_DETAIL:
      return {
        ...state,
        testKitDetail: action.payload,
      };
    case Types.SET_TEST_KIT_VISUALIZATIONS:
      return {
        ...state,
        visualization: action.payload,
      };
    default:
      return state;
  }
};